import makeAsync from "callbackToPromise";
import dhtmlxMessage from "dhtmlxMessage";

export default Object.assign(dhtmlxMessage, {
    confirm: makeAsync(window.dhtmlx.confirm, "callback"),
    modalbox: makeAsync(window.dhtmlx.modalbox, "callback"),
    alert:makeAsync(window.dhtmlx.alert, "callback"),
    message: makeAsync(window.dhtmlx.message, "callback")
});
